import React, { useState } from 'react';

const leadTimeChartTypes = [
  { key: 'scatterplot', label: '📊 Scatterplot', icon: '' },
  { key: 'histogram', label: '📈 Histograma', icon: '' },
  { key: 'outros', label: '📋 Outros', icon: '' }
];

function LeadTimeChartTypeSelector({ selectedType, onTypeChange, onExport }) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleExportClick = () => {
    setShowConfirmModal(true);
  };

  const confirmExport = () => {
    setShowConfirmModal(false);
    onExport();
  };

  const cancelExport = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-700">Lead Time</h2>
        
        {/* Toggle de visualização */}
        <div className="flex bg-gray-100 rounded-lg p-1">
          {leadTimeChartTypes.map(type => (
            <button
              key={type.key}
              onClick={() => onTypeChange(type.key)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                selectedType === type.key
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {type.icon && <span className="mr-2">{type.icon}</span>}
              {type.label}
            </button>
          ))}
          
          {/* Botão de exportar */}
          <button
            onClick={handleExportClick}
            className="px-4 py-2 rounded-md text-sm font-medium transition-colors text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            title="Exportar gráfico como imagem"
          >
            📸 Exportar
          </button>
        </div>
      </div>

      {/* Modal de confirmação */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 mx-4 max-w-md w-full">
            <div className="flex items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Exportar Gráfico</h3>
            </div>
            
            <p className="text-gray-600 mb-6">
              Deseja fazer o download do gráfico de Lead Time como imagem PNG?
            </p>
            
            <div className="flex justify-end gap-3">
              <button
                onClick={cancelExport}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={confirmExport}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium transition-colors"
              >
                Fazer Download
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default LeadTimeChartTypeSelector;
